/*
 * Mimosa — search boost v3.
 * v3: numeric style-code matching now ALSO works in the header's
 * predictive search dropdown on every page (v2 only handled the
 * /search results page, so typing "3095" in the header showed
 * "No results" with no rescue).
 */
(function () {
  'use strict';

  function skuCandidates(q) {
    var out = [];
    ['SA' + q.padStart(7, '0'), 'SA' + q.padStart(8, '0'), 'SA' + q].forEach(function (c) {
      if (out.indexOf(c) === -1) out.push(c);
    });
    return out;
  }

  function suggest(query, limit) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=' + (limit || 6) +
      '&resources[options][unavailable_products]=hide' +
      '&resources[options][fields]=title,product_type,variants.sku,tags';
    return fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { return (d && d.resources && d.resources.results && d.resources.results.products) || []; })
      .catch(function () { return []; });
  }

  function fetchNumericMatches(q, cb) {
    Promise.all(skuCandidates(q).map(function (c) { return suggest(c, 8); }))
      .then(function (lists) {
        var merged = [];
        var seen = {};
        lists.forEach(function (l) {
          l.forEach(function (p) {
            var handle = (p.url.match(/\/products\/([^\/?]+)/) || [])[1];
            if (!handle || seen[handle]) return;
            seen[handle] = true;
            merged.push(p);
          });
        });
        cb(merged);
      });
  }

  function money(p) {
    if (p === undefined || p === null || p === '') return '';
    var n = typeof p === 'string' ? parseFloat(p) : p / 100;
    if (isNaN(n)) return '';
    return '\u20B9' + n.toLocaleString('en-IN');
  }

  var css = document.createElement('style');
  css.textContent = '' +
    '.mimosa-sku-hits{border:1px solid rgba(0,0,0,.12);border-radius:8px;background:#fffdf9;padding:16px;margin:16px 0 24px}' +
    '.mimosa-sku-hits__title{font-size:13px;font-weight:600;margin-bottom:12px}' +
    '.mimosa-sku-hits__row{display:flex;gap:12px;overflow-x:auto;-webkit-overflow-scrolling:touch}' +
    '.mimosa-sku-hit{flex:none;width:110px;text-decoration:none;color:inherit}' +
    '.mimosa-sku-hit__img{display:block;width:110px;height:140px;border-radius:6px;background-size:cover;background-position:center top;border:1px solid rgba(0,0,0,.08);margin-bottom:6px}' +
    '.mimosa-sku-hit__name{display:block;font-size:11px;line-height:1.35;max-height:2.7em;overflow:hidden}' +
    '.mimosa-sku-hit__price{display:block;font-size:12px;font-weight:600;margin-top:2px}' +
    '.mimosa-sku-hits--predictive{margin:8px;padding:12px}' +
    '.mimosa-sku-hits--predictive .mimosa-sku-hit{width:84px}' +
    '.mimosa-sku-hits--predictive .mimosa-sku-hit__img{width:84px;height:104px}';
  document.head.appendChild(css);

  function buildBox(title, products, extraClass) {
    var box = document.createElement('div');
    box.className = 'mimosa-sku-hits' + (extraClass ? ' ' + extraClass : '');
    var html = '<div class="mimosa-sku-hits__title">' + title + '</div><div class="mimosa-sku-hits__row">';
    products.forEach(function (p) {
      var img = (p.featured_image && p.featured_image.url) || p.image || '';
      html += '<a class="mimosa-sku-hit" href="' + p.url.split('?')[0] + '">' +
        '<span class="mimosa-sku-hit__img" style="background-image:url(' + img + ')"></span>' +
        '<span class="mimosa-sku-hit__name">' + p.title + '</span>' +
        '<span class="mimosa-sku-hit__price">' + money(p.price) + '</span>' +
        '</a>';
    });
    html += '</div>';
    box.innerHTML = html;
    return box;
  }

  /* ---------------- predictive dropdown (all pages) ---------------- */

  var lastPredictiveQuery = '';
  var predictiveTimer = null;

  function predictiveContainer(input) {
    var root = input.closest('predictive-search, .predictive-search, form') || input.parentElement;
    if (!root) return null;
    return root.querySelector('[role="listbox"], .predictive-search__results, .predictive-search-results, [data-predictive-search]') ||
      root;
  }

  function injectPredictive(input, q, products) {
    if (!products.length) return;
    if ((input.value || '').trim() !== q) return;
    var container = predictiveContainer(input);
    if (!container) return;
    var old = container.querySelector('.mimosa-sku-hits');
    if (old) old.parentNode.removeChild(old);
    var box = buildBox('Style code \u201C' + q + '\u201D', products.slice(0, 6), 'mimosa-sku-hits--predictive');
    container.insertBefore(box, container.firstChild);
    var tries = 0;
    var keep = setInterval(function () {
      tries++;
      if ((input.value || '').trim() !== q || tries > 12) { clearInterval(keep); return; }
      if (!box.isConnected) {
        var c = predictiveContainer(input);
        if (c) c.insertBefore(box, c.firstChild);
      }
    }, 400);
  }

  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input || !input.matches) return;
    if (!input.matches('input[type="search"], .predictive-search input, [name="q"]')) return;
    var q = (input.value || '').trim();
    if (!/^\d{3,8}$/.test(q) || q === lastPredictiveQuery) return;
    if (predictiveTimer) clearTimeout(predictiveTimer);
    predictiveTimer = setTimeout(function () {
      lastPredictiveQuery = q;
      fetchNumericMatches(q, function (products) { injectPredictive(input, q, products); });
    }, 350);
  }, true);

  /* ---------------- /search results page ---------------- */

  if (location.pathname.indexOf('/search') !== 0) return;

  var params = new URLSearchParams(location.search);
  var q = (params.get('q') || '').trim();
  if (!q) return;

  function mountPoint() {
    return document.querySelector('#filter-results') ||
      document.querySelector('.template-search, main .container, main') ||
      document.body;
  }

  function persistentMount(box) {
    function insert() {
      var c = mountPoint();
      if (c && !box.isConnected) c.insertBefore(box, c.firstChild);
    }
    insert();
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (!box.isConnected) insert();
      if (tries > 30) clearInterval(timer);
    }, 500);
  }

  function renderBanner(title, products) {
    if (!products.length) return;
    persistentMount(buildBox(title, products));
  }

  function run() {
    if (/^\d{3,8}$/.test(q)) {
      fetchNumericMatches(q, function (products) {
        renderBanner('Matching style code \u201C' + q + '\u201D', products);
      });
      return;
    }

    function resultsLookEmpty() {
      if (document.querySelector('#filter-results a[href*="/products/"]')) return false;
      var text = (document.body.textContent || '').toLowerCase();
      return text.indexOf('no results') !== -1 || text.indexOf('0 results') !== -1 ||
        !document.querySelector('main a[href*="/products/"]');
    }

    var words = q.split(/\s+/).filter(function (w) { return w.length >= 3; });
    if (words.length < 1) return;

    window.setTimeout(function () {
      if (!resultsLookEmpty()) return;
      Promise.all(words.slice(0, 3).map(function (w) { return suggest(w, 6); }))
        .then(function (lists) {
          var merged = [];
          lists.forEach(function (l) { merged = merged.concat(l); });
          renderBanner('No exact match for \u201C' + q + '\u201D \u2014 closest matches', merged.slice(0, 10));
        });
    }, 800);
  }

  if (document.readyState === 'complete') {
    setTimeout(run, 300);
  } else {
    window.addEventListener('load', function () { setTimeout(run, 300); });
  }
})();
